import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlBuilderService {
  private _apiUrl: string;
  private _securityUrl: string;
  private _socketUrl: string;
  private _socketSecurityUrl: string;
  private _appUrl: string;

  constructor() {
    this.initializeUrls();
  }

  private initializeUrls(): void {
    if (environment.useSSL) {
      this._apiUrl = `${this.protocol}://${environment.serverHost}${environment.serverBasePath}`;
      this._securityUrl = `${this.protocol}://${environment.securityHost}${environment.securityBasePath}`;
      this._socketUrl = `${this.protocol}://${environment.serverHost}${environment.socketBasePath}`;
      this._socketSecurityUrl = `${this.protocol}://${environment.securityHost}${environment.socketSecurityBasePath}`;
      this._appUrl = `${this.protocol}://${environment.serverHost}`;
    } else {
      this._apiUrl = `${this.protocol}://${environment.serverHost}:${environment.serverPort}${environment.serverBasePath}`;
      this._securityUrl = `${this.protocol}://${environment.securityHost}:${environment.serverSecurityPort}${environment.securityBasePath}`;
      this._socketUrl = `${this.protocol}://${environment.serverHost}:${environment.serverSocketPort}`;
      this._socketSecurityUrl = `${this.protocol}://${environment.securityHost}:${environment.securitySocketPort}`;
      this._appUrl = `${this.protocol}://${environment.serverHost}:${environment.appPort}`;
    }
  }

  /**
   * Gets the base URL of the API
   */
  public get apiUrl(): string {
    return this._apiUrl;
  }

  /**
   * Gets the base URL of the security service
   */
  public get securityUrl(): string {
    return this._securityUrl;
  }

  /**
   * Gets the base URL of the server for sockets (without the API path)
   */
  public get socketUrl(): string {
    return this._socketUrl;
  }

  /**
   * Obtiene la URL base del servidor para sockets de seguridad (sin el path de la API)
   */
  public get socketSecurityUrl(): string {
    return this._socketSecurityUrl;
  }

  /**
   * Gets the current protocol based on the SSL configuration
   */
  public get protocol(): string {
    return environment.useSSL ? 'https' : 'http';
  }

  /**
   * Gets the base URL of the application
   */
  public get appUrl(): string {
    return this._appUrl;
  }

  /**
   * Gets only the server base path (without host) for CommunicationService
   */
  public get serverBasePath(): string {
    return environment.serverBasePath;
  }

  /**
   * Gets only the security base path (without host) for CommunicationSecurityService
   */
  public get securityBasePath(): string {
    return environment.securityBasePath;
  }

  /**
   * Gets only the socket base path (without host)
   */
  public get socketBasePath(): string {
    return environment.socketBasePath;
  }

  /**
   * Gets only the socket security base path (without host)
   */
  public get socketSecurityBasePath(): string {
    return environment.socketSecurityBasePath;
  }
}
